export default {
    /* GET_COST_CENTER_NUMBERS
    ---------------------------------------------------------------
    */
    GET_COST_CENTER_NUMBERS_REQUEST: state => {
        state.costCenterNumbersLoading = true
    },
    GET_COST_CENTER_NUMBERS_SUCCESS: (state, data) => {
        state.costCenterNumbers = data.results

        state.costCenterNumbers = state.costCenterNumbers.map(item => ({
            ...item,
            verboseName: `${item.number} - ${item.description}`
        }))
        state.costCenterNumbersLoading = false
    },
    GET_COST_CENTER_NUMBERS_FAILURE: state => {
        state.costCenterNumbersLoading = false
    },

}
